import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_PROJECTS_LIST',
  'FETCH_PROJECTS_LIST_START',
  'FETCH_PROJECTS_LIST_SUCCESS',
  'FETCH_PROJECTS_LIST_ERROR',
  'CREATE_PROJECT_LIST',
  'CREATE_PROJECT_LIST_START',
  'CREATE_PROJECT_LIST_ERROR',
  'CREATE_PROJECT_LIST_SUCCESS',
  'UPDATE_PROJECT',
  'UPDATE_PROJECT_START',
  'UPDATE_PROJECT_ERROR',
  'UPDATE_PROJECT_SUCCESS',
  'DELETE_PROJECT',
  'FETCH_PATIENT_COUNT',
]);
